export default function fiveDosesAtDays(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="11.5" fill="white" stroke="#EAEBEC" />
      <circle cx="12" cy="12" r="3" fill="url(#paint0_radial_1129_33557)" />
      <circle cx="24" cy="12" r="3" fill="url(#paint1_radial_1129_33557)" />
      <circle cx="18" cy="18" r="3" fill="url(#paint2_radial_1129_33557)" />
      <circle cx="12" cy="24" r="3" fill="url(#paint3_radial_1129_33557)" />
      <circle cx="24" cy="24" r="3" fill="url(#paint4_radial_1129_33557)" />
      <defs>
        <radialGradient
          id="paint0_radial_1129_33557"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.6838 9) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1129_33557"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.6838 9) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_1129_33557"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.6838 15) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_1129_33557"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.6838 21) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_1129_33557"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.6838 21) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
      </defs>
    </svg>
  );
}
